
document.addEventListener('DOMContentLoaded' , () =>{
	//header gnb
	const body = document.body,
		  gnbOpenBtn = document.querySelectorAll('.js-gnb-open'),
		  gnbCloseBtn = document.querySelector('.js-gnb-close'),
		  gnbToggleBtn = document.querySelectorAll('.js_gnb_toggleBtn'),
		  gnbDepth2 = document.querySelectorAll('.depth2');

	if(document.querySelector('.gnb')){
		gnbOpenBtn.forEach(function(el){
			el.addEventListener('click' , function(){
				body.classList.add('ovf');
				$(".js-gnb").show(100, function(){
					$(".js-gnb .gnb__content").stop().animate({"left":"0"}, 450);
					$('.gnb-slide-area .gnb-slide-area__list').slick('refresh');
				});

				gnbToggleBtn.forEach(function(el){
					let gnbToggleBtnArray = Array.from(el.parentNode.parentNode.querySelectorAll('.js_gnb_toggleBtn'));

					el.addEventListener('click' , function(e){
						if(el.classList.contains('active')){
							el.classList.remove('active');
						}else{
							gnbToggleBtnArray.forEach(function(el){
								el.classList.remove('active');
							});
							el.classList.add('active');
						}
					});
				})

				//gnb depth2 전체보기 하나일 때 col1 class 추가
				gnbDepth2.forEach(function(el){
					let targetLi = el.querySelectorAll('li').length;

					if(targetLi == 1){
						el.classList.add('col1');
					}
				})

				gnbCloseBtn.addEventListener('click' , function(){
					body.classList.remove('ovf');
					$(".js-gnb .gnb__content").stop().animate({"left":"-100%"}, 450);
					setTimeout(function(){
						$(".js-gnb").hide();
					}, 450);
				});
			});
		})

		$('.gnb-slide-area .gnb-slide-area__list').slick({
			// lazyLoad: 'ondemand',
            dots:true,
            arrows:false,
            autoplay:true,
        });
	}

	//header nav
	if(document.querySelector('.nav')){
        let swiper = new Swiper('.nav', {
            slidesPerView: 'auto',
            spaceBetween: 1,
        });
	}

	//header height
	let headerH = document.getElementById('header').offsetHeight,
		contentH = document.querySelector('.content');

	if(document.querySelector('.lnb')){
		let lnbH = document.querySelector('.lnb').offsetHeight;

		contentH.style.marginTop = headerH + lnbH + 'px';
	}else if(document.querySelector('.top-area')){
		let topAreaH = document.querySelector('.top-area').offsetHeight;

		contentH.style.marginTop = headerH + topAreaH + 'px';
	}else{
		contentH.style.marginTop = headerH + 'px';
	}
	
	if(document.querySelector('.event-product-lists-page') || document.querySelector('.event-view-page') || document.querySelector('.brand-product-list-page')){
		document.querySelector('.lnb').style.top = headerH + 'px';
	}
	
	// 별점 체크박스
	const starScore = document.querySelectorAll('.js-star-score');

	class starScoreBox {
		constructor(target) {
			this.target = target;
			this.starScoreLabel = this.target.querySelectorAll('label');
		}

		starScoreFn() {
			this.starScoreLabel.forEach(el => {
				el.addEventListener("click" , function(){
					let _text = el.parentElement.nextElementSibling;

					if(el.innerText == '아주 좋아요'){
						_text.innerText = '아주 좋아요';
					}else if(el.innerText == '맘에 들어요'){
						_text.innerText = '맘에 들어요';
					}else if(el.innerText == '보통이에요'){
						_text.innerText = '보통이에요';
					}else if(el.innerText == '그냥 그래요'){
						_text.innerText = '그냥 그래요';
					}else{
						_text.innerText = '별로에요';
					}
				})
			});
		}
	}    
	starScore.forEach(el => {        
		new starScoreBox(el).starScoreFn();
	});

	// 비밀번호 보기
	const hiddenShow = document.querySelectorAll('.js_hiddenShow');

	class hiddenShowBox {
		constructor(target) {
			this.target = target;
			this.hiddenShowBtn = this.target.querySelector('.hidden-show__btn');
			this.hiddenShowIp = this.target.querySelector(".hidden-show__input");
		}

		hiddenShowFn() {
			const _this = this;
			
			this.hiddenShowBtn.addEventListener("click" , function(){
				if(_this.hiddenShowIp.type === 'password'){
					_this.hiddenShowIp.type = 'text';
					_this.hiddenShowBtn.classList.add('on');
				}else{
					_this.hiddenShowIp.type = 'password';
					_this.hiddenShowBtn.classList.remove('on');
				}
			})
		}
	}    
	hiddenShow.forEach(el => {        
		new hiddenShowBox(el).hiddenShowFn();
	});

	//datepicker
	if(document.querySelector('.datepicker')){
		$(".datepicker input").datepicker({
			dateFormat: 'yy-mm-dd',
			showOtherMonths: true,
			prevText: '이전 달',
			nextText: '다음 달',
			monthNames: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
			monthNamesShort: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
			dayNames: ['일', '월', '화', '수', '목', '금', '토'],
			dayNamesShort: ['일', '월', '화', '수', '목', '금', '토'],
			dayNamesMin: ['일', '월', '화', '수', '목', '금', '토'],
			showMonthAfterYear: true,
			yearSuffix: '',
			firstDay:1
		});
	}

	//category menu - product, brand
	if(document.querySelector('.category')){
		$(".category .category__menu").slick({
			arrows:false,
			dots:false,
			variableWidth:true,
			infinite:false,
			slidesToShow:1,
			swipeToSlide:true,
		});
	}
	
	//js-square
	if(document.querySelector('.js-square')){
		/* 이미지 중앙 노출 */
		const jsSquare = document.querySelectorAll('.js-square');

		jsSquare.forEach(el => {
			let squareImg = el.querySelector('img'),
				squareImgWd = squareImg.naturalWidth,
				squareImgHg = squareImg.naturalHeight;

			// console.log(squareImgWd)
			// console.log(squareImgHg)

			if(squareImgWd > squareImgHg){
				squareImg.style.width = 'auto';
				squareImg.style.height = '100%';
				// console.log('가로 길 때');
			}else if(squareImgWd < squareImgHg){
				squareImg.style.width = '100%';
				squareImg.style.height = 'auto';
				// console.log('세로 길 때');
			}
		});
	}

	// footer - floating buton
	if(document.querySelector('.js-floating-button')){
		const floatingButton = document.querySelector('.js-floating-button');

		window.addEventListener('scroll' , ()=>{
			if(window.scrollY >= floatingButton.clientHeight){
				floatingButton.classList.add('scroll');
			} else {
				floatingButton.classList.remove('scroll');
			}
		})
	}
	
});
